import {SimplePageLayout} from '@flexinet/ui-components';
import {useApplicationProducts, ApplicationProductsComponent} from '@flexinet/pricing-components';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {SubscriptionStatusBanner} from "../../../components/SubscriptionStatusBanner.tsx";
import {useEffect} from "react";

export const IndexPage = () => {

    const {
        items: applicationProducts,
        handleFetchRecords
    } = useApplicationProducts();

    useEffect(() => {
        handleFetchRecords()
    }, []);

    const products = applicationProducts
        ?.map((applicationProduct) => applicationProduct.product)
        .filter((product): product is NonNullable<typeof product> => product != null);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >

            {products ?
                <>
                    <SubscriptionStatusBanner/>
                    <ApplicationProductsComponent products={products}/>
                </> : null}

        </SimplePageLayout>
    );
};
